import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import '@/assets/sass/app.sass'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations';
import VueTelInput from "vue-tel-input";
import messageService from 'vue-update-message';

Vue.use(VueTelInput);

const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [new Integrations.Vue({
            Vue,
            attachProps: true
        })],
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        release: process.env.VUE_APP_SENTRY_RELEASE,
        beforeSend(event, hint) {
          // Check if it is an exception, and if so, show the report dialog
          if (event.exception && process.env.VUE_APP_SENTRY_FEEDBACK) {
            Sentry.showReportDialog({ 
              eventId: event.event_id,
              lang: 'ru',   // right now sentry don't know about ru language, but this could be fix in a future.
              title: 'Кажется, что-то пошло не так',
              subtitle: 'Сообщение об ошибке уже отправлено.',
              subtitle2: 'Мы будем благодарны, если вы опишите, что случилось.',

              labelName: 'Представьтесь, пожалуйста',
              labelEmail: 'Адрес электронной почты',
              labelComments	: 'Опишите, что случилось',

              labelClose: 'Закрыть',
              labelSubmit: 'Отправить',
              errorGeneric: 'Сообщение не было отправлено. Пожалуйста, попробуйте ещё раз.',
              errorFormEntry: 'Исправьте, пожалуйста, выделенные поля',
              successMessage: 'Сообщение было отправлено. Большое спасибо.',
            });
          }
          return event;
        }
    })
}

Vue.config.productionTip = false;
Vue.use(messageService);
Vue.use(VueAxios, axios);
Vue.use(VueAnalytics, {
    id: 'UA-139441109-1',
    router
});
const SERVER_URL = process.env.VUE_APP_SERVER_URL ? process.env.VUE_APP_SERVER_URL : 'https://croinc.bearle.ru';

Vue.mixin({
    data() {
        return {
            SERVER_URL,
            API_URL: `${SERVER_URL}/api/v1`
        }
    }
})

new Vue({
    store,
    router,
    render: h => h(App),
    created() {
    }
}).$mount('#app')

